// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
var DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var SharedPostEmailStatsSingleRecipient = require("./SharedPostEmailStatsSingleRecipient.bs.js");
var SharedPostEmailStatsButtonQuery_graphql = require("../../../__generated__/SharedPostEmailStatsButtonQuery_graphql.bs.js");

var convertVariables = SharedPostEmailStatsButtonQuery_graphql.Internal.convertVariables;

var convertResponse = SharedPostEmailStatsButtonQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = SharedPostEmailStatsButtonQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, SharedPostEmailStatsButtonQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, SharedPostEmailStatsButtonQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(SharedPostEmailStatsButtonQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(SharedPostEmailStatsButtonQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(SharedPostEmailStatsButtonQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(SharedPostEmailStatsButtonQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function SharedPostEmailStatsButton$Modal(props) {
  var onRefresh = props.onRefresh;
  var data = usePreloaded(props.queryRef);
  var match = data.sharedPropertyV5;
  if (match === undefined) {
    return JsxRuntime.jsx(FragmentErrorBoundary.ErrorState.make, {
                fragmentDisplayName: "email stats"
              });
  }
  if (match.__typename !== "SharedPropertyV5") {
    return UnselectedUnionMemberError.raise("Unselected union member: " + match._0 + " in SharedPostEmailStatsButton query");
  }
  var recipients = Core__Array.keepSome(Core__Option.getOr(Core__Option.flatMap(match.contacts, (function (c) {
                    return c.edges;
                  })), [])).map(function (r) {
        return r.emailStats;
      });
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                            onClick: (function (param) {
                                onRefresh();
                              }),
                            size: "small",
                            _type: "button",
                            children: Caml_option.some(JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Icon__Jsx3.make, {
                                              icon: "Refresh",
                                              size: 16
                                            }),
                                        "Refresh stats"
                                      ],
                                      className: "flex items-center gap-2"
                                    }))
                          }),
                      className: "flex flex-row justify-end mb-4"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("ul", {
                            children: [
                              JsxRuntime.jsxs("li", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: "Recipient",
                                            className: "text-left p-4 font-medium text-gray-700"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: "Status",
                                            className: "text-right p-4 font-medium text-gray-700"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: "Clicks",
                                            className: "text-right p-4 font-medium text-gray-700"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: "Last clicked",
                                            className: "text-right p-4 font-medium text-gray-700"
                                          })
                                    ],
                                    className: "hidden md:grid md:grid-cols-4 bg-gray-50"
                                  }),
                              recipients.map(function (r, index) {
                                    return JsxRuntime.jsx(SharedPostEmailStatsSingleRecipient.make, {
                                                recipient: r.fragmentRefs
                                              }, index.toString());
                                  })
                            ],
                            className: "w-full divide-y divide-gray-200 bg-white"
                          }),
                      className: "rounded-lg border border-gray-200 overflow-hidden"
                    })
              ],
              className: "min-w-[320px]"
            });
}

var Modal = {
  make: SharedPostEmailStatsButton$Modal
};

function SharedPostEmailStatsButton(props) {
  var sharedMessageId = props.sharedMessageId;
  var match = useLoader();
  var loadQuery = match[1];
  var queryRef = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowModal = match$1[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs(DialogV5.make, {
                      title: "Email Stats",
                      isOpen: match$1[0],
                      ariaLabel: "Email Stats",
                      onDismiss: (function () {
                          setShowModal(function (param) {
                                return false;
                              });
                        }),
                      size: "XXLarge",
                      showCloseButton: true,
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: "This shows how recipients have engaged with your email",
                                    className: "prose max-w-none"
                                  }),
                              className: "mb-4"
                            }),
                        queryRef !== undefined ? JsxRuntime.jsx(React.Suspense, {
                                children: Caml_option.some(JsxRuntime.jsx(FragmentErrorBoundary.make, {
                                          fragmentDisplayName: "email stats",
                                          children: JsxRuntime.jsx(SharedPostEmailStatsButton$Modal, {
                                                queryRef: Caml_option.valFromOption(queryRef),
                                                onRefresh: (function () {
                                                    loadQuery({
                                                          sharedMessageId: sharedMessageId
                                                        }, "network-only", undefined);
                                                  })
                                              })
                                        })),
                                fallback: Caml_option.some(JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(Loader.make, {}),
                                          className: "mt-4"
                                        }))
                              }) : null,
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                    onClick: (function (param) {
                                        setShowModal(function (param) {
                                              return false;
                                            });
                                      }),
                                    _type: "button",
                                    children: "Close"
                                  }),
                              className: "flex flex-row justify-end gap-4 mt-10"
                            })
                      ]
                    }),
                JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                      onClick: (function (param) {
                          loadQuery({
                                sharedMessageId: sharedMessageId
                              }, "network-only", undefined);
                          setShowModal(function (param) {
                                return true;
                              });
                        }),
                      size: "small",
                      children: "Email Stats"
                    })
              ]
            });
}

var make = SharedPostEmailStatsButton;

exports.Query = Query;
exports.Modal = Modal;
exports.make = make;
/* use Not a pure module */
